/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeOwnPasswordRequest
 */
export interface ChangeOwnPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeOwnPasswordRequest
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeOwnPasswordRequest
     */
    currentOtp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeOwnPasswordRequest
     */
    password: string;
}

export function ChangeOwnPasswordRequestFromJSON(json: any): ChangeOwnPasswordRequest {
    return ChangeOwnPasswordRequestFromJSONTyped(json, false);
}

export function ChangeOwnPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeOwnPasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentPassword': json['current_password'],
        'currentOtp': !exists(json, 'current_otp') ? undefined : json['current_otp'],
        'password': json['password'],
    };
}

export function ChangeOwnPasswordRequestToJSON(value?: ChangeOwnPasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_password': value.currentPassword,
        'current_otp': value.currentOtp,
        'password': value.password,
    };
}


